import {ElementType} from '@app/modules/svg/dataSource/constant/ElementType';
import {Point} from '@app/modules/svg/model/Point';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';
import {MoveDrawer} from '@app/modules/svg/service/tool/draw/mode/MoveDrawer';
import {MoveDrawable} from '@app/modules/svg/service/tool/draw/type/MoveDrawable';
import {TanView} from '@app/modules/svg/element/complex/cartesian/graphic/TanView';

export class DrawTan extends MoveDrawer {
  protected createDrawableElement(position: Point): MoveDrawable {
    return new TanView(
      this.drawTool.container,
      {overEvent: true, globalStyle: true, periods: 2},
      position,
      position
    );
  }

  public override start(call: boolean): void {
    super.start(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.TAN_TOOL_ON);
    }
  }
  public override stop(call: boolean): void {
    super.stop(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.TAN_TOOL_OFF);
    }
  }

  public _new(): DrawTan {
    return new DrawTan(this.drawTool);
  }
  public get type(): ElementType {
    return ElementType.TAN;
  }
}
